(ns frontend.view.settings2.surveys.template-editor
  (:require
   [common.localization :as loc]
   [ui.components.reorder-controls.view :as reorder-controls]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.nev.surveys.form.components :as components]
   [frontend.view.settings2.surveys.components :as survey-components]
   [frontend.view.settings2.surveys.events :as events]
   [frontend.view.settings2.surveys.sub :as sub]
   [frontend.view.settings2.surveys.timeseries.view :as timeseries]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.ck-editor.view :as ck-editor]
   [ui.components.modal.style :as modal-style]
   [ui.components.modal.view :as modal]
   [ui.components.query-builder.view :as query-builder]
   [ui.components.select.select :as select]
   [ui.editors.data-input :as data-input]
   [ui.components.sortable-list.view :as sortable-list]))


(defn add-block-select
  []
  [select/view
   {:value       {:value nil
                  :label ""}
    :on-change   #(rf/dispatch [::events/add-block %])
    :placeholder (loc/tr :add-survey-block)
    :options     [{:value :survey-block/wysiwyg
                   :label (loc/tr :survey-block/wysiwyg)}
                  {:value :survey-block/section
                   :label (loc/tr :survey-block/section)}
                  {:value :survey-block/table-block
                   :label (loc/tr :survey-block/table-block)}]}])


(defn add-content-item-select
  [db-path]
  [select/view
   {:value       {:value nil
                  :label ""}
    :on-change   #(rf/dispatch [::events/add-survey-item db-path false %])
    :placeholder (loc/tr :add-survey-block)
    :options     [{:value :survey-item/wysiwyg
                   :label (loc/tr :add-survey-item-wysiwyg)}
                  {:value :survey-item/question
                   :label (loc/tr :add-survey-item-questions)}]}])

(defn mandatoriness-select
  [{:keys [db-path] :as question}]
  (let [visibility (:visibility question)
        options (remove nil?
                        [(if (some #{visibility} [:visibility/conditional])
                           {:value :mandatory/when-visible
                            :label (loc/tr :mandatory/when-visible)}
                           {:value :mandatory/always
                            :label (loc/tr :mandatory/always)})
                         (if (some #{visibility} [:visibility/conditional])
                           {:value :mandatory/conditional-when-visible
                            :label (loc/tr :mandatory/conditional-when-visible)}
                           {:value :mandatory/conditional
                            :label (loc/tr :mandatory/conditional)})
                         {:value :mandatory/optional
                          :label (loc/tr :mandatory/optional)}])]
    (when-not (= visibility :visibility/hidden)
      [:div
       [select/view
        {:value       (->> options
                           (cu/filter-by :value (:mandatoriness question))
                           (first))
         :on-change   #(rf/dispatch [::events/set (concat db-path [:mandatoriness]) %])
         :placeholder (loc/tr :select-mandatoriness-level)
         :options     options}]])))

(defn skip-select
  [{:keys [db-path] :as question}]
  (let [visibility (:visibility question)
        options [{:value false
                  :label (loc/tr :can-skip?)}
                 {:value true
                  :label (loc/tr :cannot-skip?)}]]
    (when (and (not= visibility :visibility/hidden)
               (session/has-feature-access? :feature/survey-skip-responses))
      [:div
       [select/view
        {:id        (str "survey-question-skip-" db-path)
         :value     (->> options
                         (cu/filter-by :value (:cannot-skip? question))
                         (first))
         :on-change #(rf/dispatch [::events/set (concat db-path [:cannot-skip?]) %])
         :options   options}]])))

(defn visibility-select
  [{:keys [db-path] :as question}]
  (let [visibility (or (:visibility question)
                       :visibility/always)
        options [{:value :visibility/always
                  :label (loc/tr :visibility/always)}
                 {:value :visibility/conditional
                  :label (loc/tr :visibility/conditional)}
                 {:value :visibility/hidden
                  :label (loc/tr :visibility/hidden)}]]
    [select/view
     {:value       (->> options
                        (cu/filter-by :value visibility)
                        (first))
      :on-change   (fn [e]
                     (rf/dispatch [::events/set (concat db-path [:visibility]) e]))
      :placeholder (loc/tr :select-visibility-level)
      :options     options}]))

(defn survey-item-wysiwyg-config
  [{:keys [db-path selected-questions-options question-choices query-schema] :as item}]
  (let [visibility (or (:visibility item)
                       :visibility/always)]
    [:<>
     [visibility-select item]
     (when (= visibility :visibility/conditional)
       [query-builder/view
        {:label            (loc/tr :question-is-visible-when)
         :db-path          (concat db-path [:visibility-rules])
         :rules            (:visibility-rules item)
         :level            0
         :field-options    selected-questions-options
         :question-choices question-choices
         :query-schema     query-schema}])]))

(defn wysiwyg-block
  [{:keys [lang db-path] :as block}]
  [ck-editor/editor
   {:value     (:localized-content block)
    :on-change (fn [v]
                 (rf/dispatch [::events/set (concat db-path [:content lang]) v]))}])

(defn section-heading
  [{:keys [lang db-path] :as block}]
  [:div
   {:class "flex flex-col gap-2"}
   [:label
    {:class "text-semibold"}
    (loc/tr :survey-section-label)]
   [data-input/view
    {:data-type :data.type/text-simple
     :value     (:localized-label block)
     :on-blur   (fn [v]
                  (rf/dispatch [::events/set (concat db-path [:label lang]) v]))}]])

(defn section-info
  [{:keys [lang db-path] :as block}]
  [:div
   {:class "p-4 flex flex-col gap-2 border border-solid border-base-light-border-paler rounded lg:w-5/12"}
   [:label
    {:class "text-semibold hover:text-base-regular-text"}
    (loc/tr :survey-section-info)]
   [data-input/view
    {:data-type     :data.type/text-richtext
     :border?       true
     :focus-border? true
     :value         (:localized-info block)
     :on-blur       #(rf/dispatch [::events/set (concat db-path [:info lang]) %])}]])


(defn survey-item-tools
  [{:keys [db-path first? last?]}]
  [reorder-controls/view
   {:first?         first?
    :last?          last?
    :remove-label   (loc/tr :survey-block-editor/remove-item)
    :on-move-to-top #(rf/dispatch [::events/move-item-first db-path])
    :on-move-up     #(rf/dispatch [::events/move-item-up db-path])
    :on-move-down   #(rf/dispatch [::events/move-item-down db-path])
    :on-remove      #(rf/dispatch [::events/remove-vec-item db-path])}])

(defn survey-item-wysiwyg
  [{:keys [lang db-path] :as item}]
  [:div
   {:class "flex flex-col gap-3"}
   [survey-item-tools item]
   [survey-item-wysiwyg-config item]
   [data-input/view
    {:data-type     :data.type/text-richtext
     :focus-border? true
     :border?       true
     :value         (:localized-content item)
     :on-change     #(rf/dispatch [::events/set (concat db-path [:content lang]) %])}]])

(defn question-label
  [question]
  (if-let [localized-label (:localized-label question)]
    [:span
     {:class "inline-block text-semibold "}
     localized-label]
    [:span
     {:class ""}
     (:other-lang-label question)]))

(defn info-text
  [{:keys [lang db-path] :as item}]
  [data-input/view
   {:data-type     :data.type/text-richtext
    :value         (:localized-info item)
    :focus-border? true
    :placeholder   (loc/tr :survey-question/info-text-placeholder)
    :on-blur       #(rf/dispatch [::events/set (concat db-path [:survey-question/info-translations lang]) %])}])


(defn survey-item-question-label
  [{:keys [survey-question/data-unit] :as question}]
  [:label
   {:class "text-semibold"}
   [question-label question]
   (when data-unit
     [:span
      {:class ""}
      "(" (:survey-question/data-unit question) ")"])])

(defn survey-item-question-config
  [{:keys [lang selected-questions-options question-choices query-schema db-path] :as question}]
  (let [mandatoriness (:mandatoriness question)
        visibility (:visibility question)
        hide-skip? @(rf/subscribe [::sub/hide-no-answer?])
        excel-info-use? @(rf/subscribe [::sub/excel-info-show?])]
    [:<>
     [:div
      [visibility-select question]]
     (when (= visibility :visibility/conditional)
       [query-builder/view
        {:label            (loc/tr :question-is-visible-when)
         :db-path          (concat db-path [:visibility-rules])
         :rules            (:visibility-rules question)
         :level            0
         :field-options    selected-questions-options
         :question-choices question-choices
         :query-schema     query-schema}])
     [mandatoriness-select question]
     (when (or (and (= :visibility/always visibility)
                    (= :mandatory/conditional mandatoriness))
               (and (= :visibility/conditional visibility)
                    (= :mandatory/conditional-when-visible mandatoriness)))
       [:<>
        [query-builder/view
         {:label            (if (= :visibility/always visibility)
                              (loc/tr :this-question-is-mandatory-when)
                              (loc/tr :this-question-is-mandatory-when-visible-and))
          :db-path          (concat db-path [:mandatoriness-rules])
          :rules            (:mandatoriness-rules question)
          :level            0
          :field-options    selected-questions-options
          :question-choices question-choices
          :query-schema     query-schema}]])

     (when (and (not hide-skip?)
                (some #{mandatoriness} [:mandatory/always :mandatory/when-visible :mandatory/conditional-when-visible]))
       [skip-select question])

     (when (some #{(:survey-question/data-type question)}
                 [:data.type/number
                  :data.type/currency-value
                  :data.type/percentage
                  :data.type/calculated-number
                  :data.type/multiplier])
       [:<>
        [:label
         {:class "text-semibold"}
         (loc/tr :number-precision)]
        [data-input/view
         {:data-type :data.type/integer
          :value     (:precision question)
          :on-change #(rf/dispatch [::events/set (concat db-path [:precision]) %])}]])

     (when excel-info-use?
       [:<>
        [:h3
         {:class "pt-2 text-semibold"}
         (loc/tr :excel-visibility-infos)]
        [:ul
         {:class "flex flex-col flex-auto gap-1"}
         (some->> (:visibility-infos question)
                  (seq)
                  (map-indexed (fn [idx {:keys [code label]}]
                                 (let [localized-code (get code lang)
                                       localized-label (get label lang)]
                                   ^{:key (str db-path "-visibility-" idx)}
                                   [:li.flex.flex-row.flex-auto.justify-items-start.gap-1.align-items-center
                                    [:div
                                     [data-input/view
                                      {:data-type :data.type/text-simple
                                       :value     localized-code
                                       :on-blur   (fn [new-value]
                                                    (rf/dispatch [::events/set (concat db-path [:visibility-infos idx :code lang]) new-value]))}]]
                                    [:div
                                     [data-input/view
                                      {:data-type :data.type/text-simple
                                       :value     localized-label
                                       :on-blur   (fn [new-value]
                                                    (rf/dispatch [::events/set (concat db-path [:visibility-infos idx :label lang]) new-value]))}]]
                                    [:i.fal.fa-times-circle.text-danger
                                     {:on-click (fn [_]
                                                  (rf/dispatch [::events/set (concat db-path [:visibility-infos])
                                                                (cu/vec-remove idx (vec (:visibility-infos question)))]))}]]))))
         [:li
          {:class "flex flex-row flex-auto"}
          [button/sm-secondary-hollow
           {:on-click (fn []
                        (rf/dispatch [::events/set (concat db-path [:visibility-infos]) (vec (concat (:visibility-infos question)
                                                                                                     [{:code  nil
                                                                                                       :label nil}]))]))}
           (loc/tr :add-visibility-info)]]]])]))

(defn survey-item-question
  [question]
  [:div
   {:class "flex flex-col gap-3"}
   [:div
    {:class "flex flex-col gap-3"}
    [survey-item-question-label question]
    [survey-item-question-config question]]
   [:div
    {:class "flex flex-col gap-3"}
    [survey-item-tools question]
    [info-text question]]])

(defn section-content-item
  [{:keys [survey-item-type] :as props}]
  [:div
   {:class "p-4 border border-solid border-base-regular-border-paler rounded "}
   (case survey-item-type
     :survey-item/wysiwyg
     [survey-item-wysiwyg props]
     :survey-item/question
     [survey-item-question props]
     (do (js/console.log "Unknown survey type : " survey-item-type)
         (str "Item " (pr-str props))))])

(defn section-content
  [{:keys [lang content selected-questions-options question-choices query-schema db-path]}]
  [:div
   {:class "flex flex-col gap-3"}
   (into
    [:ul
     {:class "flex flex-col gap-2"}]
    (->> content
         (map-indexed (fn [index item]
                        ^{:key (str "template-editor-section-" db-path "-" index "-" (:db/id item))}
                        [section-content-item
                         (assoc item
                                :lang lang
                                :selected-questions-options selected-questions-options
                                :question-choices question-choices
                                :query-schema query-schema
                                :db-path (concat db-path [:content index])
                                :first? (zero? index)
                                :last? (= index (dec (count content))))]))
         (doall)))
   [add-content-item-select (concat db-path [:content])]])

(defn timeseries-block
  [ctx block]
  [timeseries/view ctx block])

(defn section-block
  [block]
  [:div
   {:class "flex flex-col gap-3"}
   [section-heading block]
   [:div
    {:class "flex flex-col gap-4"}
    (when (:content block)
      [section-content block])
    [section-info block]]])

(defn block
  [{:keys [idx block-type db-path first? last?] :as block}]
  [components/survey-card
   [:<>
    [reorder-controls/view
     {:first?            first?
      :last?             last?
      :move-to-top-label (loc/tr :survey-block-editor/move-section-to-top)
      :move-up-label     (loc/tr :survey-block-editor/move-section-up)
      :move-down-label   (loc/tr :survey-block-editor/move-section-down)
      :remove-label      (loc/tr :survey-block-editor/remove-section)
      :on-move-to-top    #(rf/dispatch [::events/move-block-first db-path])
      :on-move-up        #(rf/dispatch [::events/move-block-up db-path])
      :on-move-down      #(rf/dispatch [::events/move-block-down db-path])
      :on-remove         #(rf/dispatch [::events/remove-vec-item db-path])}]
    (case block-type
      :survey-block/wysiwyg [wysiwyg-block block]
      :survey-block/section [section-block block]
      :survey-block/table-block [timeseries-block {:block-idx idx
                                                   :ctx-path  db-path}
                                 block]
      (str block-type))]])

(defn survey-blocks-list
  []
  (let [keyed-survey-blocks @(rf/subscribe [::sub/keyed-survey-blocks])
        excluded-keys (->> keyed-survey-blocks
                           (map :key)
                           (sort))]
    [:div
     {:class ""}
     [:div
      {:class "flex flex-col gap-2"}
      [:label
       {:class "text-[14px] text-input-light-text font-semibold"}
       (loc/tr :survey-template/template-blocks)]

      [sortable-list/view
       {:items (mapv :item keyed-survey-blocks)
        :get-key :value
        :gap 8
        :on-reorder (fn [{:keys [source-index destination-index]}]
                      (rf/dispatch-sync [::events/reorder-survey-blocks source-index destination-index]))
        :render-item (fn [{:keys [item]}]
                       (let [{:keys [label value]} item]
                         [:div
                          {:class "flex gap-2 h-10 items-center rounded px-2 py-1 border cursor-default  bg-white"}
                          [:div
                           {:class "cursor-grab text-sm m-0"}
                           [sortable-list/drag-handle-icon
                            {:width 16}]]
                          [:div
                           {:class "grow"}
                           [:p
                            {:class "text-sm m-0"}
                            label]]
                          [:div
                           [button/square-secondary-open
                            {:class      "group"
                             :tooltip    (loc/tr :settings.surveys/remove-block-from-template)
                             :aria-label (loc/tr :settings.surveys/remove-block-from-template)
                             :on-click   (fn [_]
                                           (rf/dispatch [::events/remove-survey-block value]))}
                            [:i.fal.fa-trash
                             {:class "group-hover:text-danger-regular text-xs m-0"}]]]]))}]

      [:div
       {:class ""}
       ^{:key (str "survey-block-search-" excluded-keys)}
       [data-input/view
        {:placeholder        (loc/tr :add-template-block)
         :data-type          :data.type/ref-single
         :editor-type        :editor.type/search
         :on-change          (fn [value]
                               (when value
                                 (rf/dispatch [::events/add-block-to-template value])))
         :value              nil                                                                    ;; control -> choose the value outside, not inside the component
         ;; extra params for the component
         :exclude-values     excluded-keys
         :field/entity-types [:entity.type/survey-block]}]]]]))

(defn editor-body
  []
  (let [supported-languages @(rf/subscribe [::sub/template-languages])
        version @(rf/subscribe [::sub/template-version])
        qualitative-questions? @(rf/subscribe [::sub/qualitative-questions?])
        config @(rf/subscribe [::sub/template-config])
        lang @(rf/subscribe [::sub/selected-language])
        reference-period @(rf/subscribe [::sub/reference-period])
        multi-survey? @(rf/subscribe [::sub/multi-survey?])
        show-questions-ext-ids? @(rf/subscribe [::sub/show-questions-ext-ids?])
        hide-no-answer? @(rf/subscribe [::sub/hide-no-answer?])
        excel-info-use? @(rf/subscribe [::sub/excel-info-show?])
        excel-info-text @(rf/subscribe [::sub/excel-info-text lang])
        selected-questions-options @(rf/subscribe [::sub/all-question-options])
        all-question-choices @(rf/subscribe [::sub/all-question-choices])
        query-schema @(rf/subscribe [::sub/query-schema])
        mandatoriness-style @(rf/subscribe [::sub/mandatoriness-style])]
    [:div
     {:key   (str "template-editor-" lang)
      :class "p-4 lg:w-5xl mx-auto flex flex-col gap-4"}
     [:div
      {:class "flex flex-col gap-4"}
      [:div
       {:class "text-xl font-bold"}
       (loc/tr :configuration)]
      [:div
       {:class "flex flex-col gap-4"}
       [survey-components/lang-selector lang supported-languages]
       [:div
        {:class "grid grid-cols-2 gap-4"}
        [survey-components/reference-period-selector :en reference-period]
        (when (and qualitative-questions?
                   (session/survey-multi-responses?))
          [survey-components/multi-survey-selector :en multi-survey?])
        (when (and qualitative-questions?
                   (session/survey-multi-responses?))
          [survey-components/show-question-ext-ids-selector :en show-questions-ext-ids?])
        (when (and qualitative-questions?
                   (session/survey-skip-responses?))
          [survey-components/hide-optional-selector :en hide-no-answer?])
        (when qualitative-questions?
          [survey-components/mandatoriness-style :en mandatoriness-style])
        (when (and qualitative-questions?
                   (session/survey-excel-import?))
          [survey-components/excel-info lang excel-info-use? excel-info-text])]]]
     (->> config
          :blocks
          (map-indexed (fn [idx block-item]
                         ^{:key (str "template-editor-" idx "-block")}
                         [block
                          (assoc block-item
                                 :selected-questions-options selected-questions-options
                                 :question-choices all-question-choices
                                 :query-schema query-schema
                                 :lang lang
                                 :first? (= idx 0)
                                 :last? (= idx (dec (count (:blocks config))))
                                 :db-path [::sub/config-draft :blocks idx]
                                 :idx idx)]))
          (doall))
     (if (not= version "2")
       [add-block-select]
       [survey-blocks-list])]))

(defn editor-footer
  []
  (let [changes? @(rf/subscribe [::sub/config-draft-changes?])]
    [:div
     {:class "flex mx-auto w-5xl justify-between"}
     [:div
      {:class "flex gap-3"}
      (if changes?
        [button/secondary-hollow
         {:on-click #(rf/dispatch [::events/close-template-editor])}
         (loc/tr :close-without-saving)]
        [button/secondary-hollow
         {:on-click #(rf/dispatch [::events/close-template-editor])}
         (loc/tr :close)])]
     [:div
      [button/primary-solid
       {:disabled? (not changes?)
        :on-click  #(rf/dispatch [::events/save-template])}
       (loc/tr :save)]]]))

(defn view
  []
  [modal/view
   {:visible? true
    :hide!    #(rf/dispatch [::events/close-template-editor])
    :z-index  60000
    :size     ::modal-style/full}
   nil
   [editor-body]
   [editor-footer]])
